/**
 * @generated SignedSource<<2d9351743052f13150fca76dd44c030f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CandidateAvatar_candidate$data = {
  readonly id: string;
  readonly name: string;
  readonly profileImage: {
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "CandidateAvatar_candidate";
};
export type CandidateAvatar_candidate$key = {
  readonly " $data"?: CandidateAvatar_candidate$data;
  readonly " $fragmentSpreads": FragmentRefs<"CandidateAvatar_candidate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateAvatar_candidate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "profileImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Candidate",
  "abstractKey": null
};

(node as any).hash = "6ccca2f9f9eec0705f683f907a15255e";

export default node;
